export type LeadSourceApiRow = {
  id: string
  name: string
  active: boolean
}

export function parseActiveLeadSourceNames(rows: LeadSourceApiRow[]): string[] {
  return rows
    .filter((row) => row.active)
    .map((row) => row.name.trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
}

type ApiGet = (url: string) => Promise<{ data: { data?: LeadSourceApiRow[] } }>

export async function fetchActiveLeadSourceNames(apiGet: ApiGet) {
  try {
    const resp = await apiGet('/lead-sources')
    const rows = (resp.data.data ?? []) as LeadSourceApiRow[]
    return { options: parseActiveLeadSourceNames(rows), loadError: false as const }
  } catch {
    return { options: [] as string[], loadError: true as const }
  }
}
